module.exports = __webpack_public_path__ + "static/media/e20.a1f4036d.jpg";